"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuctioneerPreviousCurrentNext = void 0;
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var manual_current_lot_1 = require("../../../../../api/calls/lot/v3/manual_current_lot");
var main_1 = require("../../../../../reducers/slices/main");
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
var socket_1 = require("../../../../../socket");
var AuctioneerPreviousCurrentNext = function (props) {
    var _a, _b, _c;
    var currentLotChanged = props.currentLotChanged, currentBid = props.currentBid;
    var dispatch = (0, react_redux_1.useDispatch)();
    var _d = (0, react_1.useState)(null), pcn = _d[0], setPcn = _d[1];
    var _e = (0, react_1.useState)(null), newBid = _e[0], setNewBid = _e[1];
    var _f = (0, react_1.useState)(false), flash = _f[0], setFlash = _f[1];
    var mainAuction = (0, react_redux_1.useSelector)(function (state) { return state.consoleState; }).mainAuction;
    (0, react_1.useEffect)(function () {
        if (mainAuction === null || mainAuction === void 0 ? void 0 : mainAuction.entity_id) {
            socket_1.socket.off("currentLot");
            socket_1.socket.on("currentLot", function (data) {
                getPCN();
            });
            getPCN();
        }
    }, [mainAuction === null || mainAuction === void 0 ? void 0 : mainAuction.entity_id]);
    (0, react_1.useEffect)(function () {
        // when this currentBid changes, we need to clash the current lot green
        if (currentBid != null && currentBid != newBid) {
            setNewBid(currentBid);
            setFlash(true);
            setTimeout(function () {
                setFlash(false);
            }, 5000);
        }
    }, [currentBid]);
    function getPCN() {
        (0, manual_current_lot_1.manual_previous_current_next)({
            auction_entity_id: mainAuction.entity_id,
        }).then(function (response) {
            var _a;
            if (response.data.success) {
                setPcn(response.data.content);
                currentLotChanged((_a = response.data.content) === null || _a === void 0 ? void 0 : _a.current);
            }
            else {
                dispatch((0, main_1.setMessageModal)({
                    title: "Error",
                    messages: [response.data.message],
                }));
            }
        });
    }
    return pcn ? (react_1.default.createElement("div", { className: "grid grid-cols-7 border-4 border-bluer rounded-xl overflow-clip" },
        react_1.default.createElement("div", { className: "flex flex-col col-span-2\n          ".concat(((_a = pcn.previous) === null || _a === void 0 ? void 0 : _a.entity_id) && "", "\n        "), onClick: function () {
                // manualSetCurrent(pcn.previous?.entity_id);
            } },
            react_1.default.createElement("div", { className: "font-bold text-xl text-center bg-bluer pb-1 text-white" }, "PREVIOUS"),
            pcn.previous ? ( //
            react_1.default.createElement("div", { className: "flex-1" },
                react_1.default.createElement("div", { className: "w-full h-[200px] relative" },
                    react_1.default.createElement("img", { className: "w-full h-full object-cover absolute", src: pcn.previous.images && pcn.previous.images[0].uploaded_file_url })),
                react_1.default.createElement(LotNumTitle, { lot: pcn.previous }))) : (react_1.default.createElement("div", { className: "flex-1 flex items-center justify-center bg-red-300" }, "No Previous Lot"))),
        react_1.default.createElement("div", { className: "flex flex-col col-span-3" },
            react_1.default.createElement("div", { className: "font-bold text-xl text-center bg-bluer pb-1 text-white" }, "CURRENT"),
            (pcn === null || pcn === void 0 ? void 0 : pcn.current) ? ( //
            react_1.default.createElement("div", { className: "flex flex-col items-center ".concat(flash ? "bg-green-600 p-4" : "", "\n              border-l-4 border-r-4 border-l-red-500 border-r-green-500 h-full\n            ") },
                react_1.default.createElement("div", { className: "w-full h-[250px] relative" },
                    react_1.default.createElement("img", { className: "w-full h-full object-cover absolute", src: (pcn === null || pcn === void 0 ? void 0 : pcn.current.images) && ((_b = pcn === null || pcn === void 0 ? void 0 : pcn.current.images[0]) === null || _b === void 0 ? void 0 : _b.uploaded_file_url) })),
                react_1.default.createElement(LotNumTitle, { lot: pcn === null || pcn === void 0 ? void 0 : pcn.current }))) : ("No Current Lot")),
        react_1.default.createElement("div", { className: "flex flex-col col-span-2\n          ".concat(((_c = pcn.next) === null || _c === void 0 ? void 0 : _c.entity_id) && "", "\n        "), onClick: function () {
                var _a;
                if ((_a = pcn.next) === null || _a === void 0 ? void 0 : _a.entity_id) {
                    // manualSetCurrent(pcn.next.entity_id);
                }
            } },
            react_1.default.createElement("div", { className: "font-bold text-xl text-center bg-bluer pb-1 text-white" }, "NEXT"),
            pcn.next ? ( //
            react_1.default.createElement("div", { className: "flex-1" },
                react_1.default.createElement("div", { className: "w-full h-[200px] relative" },
                    react_1.default.createElement("img", { className: "w-full h-full object-cover absolute", src: pcn.next.images && pcn.next.images[0].uploaded_file_url })),
                react_1.default.createElement(LotNumTitle, { lot: pcn.next }))) : (react_1.default.createElement("div", { className: "flex-1 flex items-center justify-center bg-red-300" }, "No Next Lot"))))) : (react_1.default.createElement("div", { className: "grid grid-cols-3" }, "No PCN detected."));
};
exports.AuctioneerPreviousCurrentNext = AuctioneerPreviousCurrentNext;
var LotNumTitle = function (props) {
    var lot = props.lot;
    return (react_1.default.createElement("div", { className: "p-2 flex flex-col items-center justify-center z-10" },
        react_1.default.createElement("div", { className: "flex gap-1 items-center justify-center" },
            react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { className: "text-2xl", icon: pro_solid_svg_icons_1.faHashtag }),
            react_1.default.createElement("span", { className: "font-extrabold text-3xl" }, lot.lot_number)),
        react_1.default.createElement("div", { className: "text-3xl font-bold text-center" }, lot.title)));
};
